import UrlGeneration from '@lovata/url-generation';

export default new class CategoryBlogSearch {
  constructor() {
    this.searchWrapper = '_blog-search__wrapper';
    this.postHeaderWrapper = '_blog-post-header__wrapper';
    this.postListWrapper = '_blog-post-list__wrapper';
    this.paginationWrapper = '_blog-post-pagination__wrapper';

    this.sSearchInput = '_blog-search-input';
    this.sSearchIconActive = '_blog-search-icon';
    this.sSearchIconClose = '_blog-search-close';
    this.sSearchState = '';
    this.iSearchDelay = 600;
    this.iSearchLimit = 2;

    this.initSearch();
    this.closeSearch();
  }

  initSearch() {
    $(document)
      .on('input', `.${this.sSearchInput}`, (obEvent) => {
        let sSearchString = $(obEvent.currentTarget)
          .val();

        sSearchString = sSearchString.trim();
        // eslint-disable-next-line max-len
        if (sSearchString.length < this.iSearchLimit && this.sSearchState.length < this.iSearchLimit) {
          UrlGeneration.init();
          UrlGeneration.set('search', sSearchString);
          UrlGeneration.update();
          return;
        }

        this.obTimer = setTimeout(() => {
          $.request('onAjax', {
            data: {
              search: sSearchString,
            },
            update: {
              'blog/category-post-list/category-post-list-header-ajax': `.${this.postHeaderWrapper}`,
              'blog/category-post-list/category-post-list-ajax': `.${this.postListWrapper}`,
              'blog/category-post-list/category-post-list-pagination-ajax': `.${this.paginationWrapper}`,
            },
            success(res) {
              UrlGeneration.init();
              UrlGeneration.set('search', sSearchString);
              UrlGeneration.update();
              $('._blog-search-icon').fadeOut();
              $('._blog-search-close').fadeIn();
              this.success(res);
            },
          });
        }, this.iSearchDelay);
      });
  }

  closeSearch() {
    $(document).on('click', `.${this.sSearchIconClose}`, () => {
      const sSearchString = '';
      $.request('onAjax', {
        data: {
          search: sSearchString,
        },
        update: {
          'blog/category-post-list/category-post-list-search': `.${this.searchWrapper}`,
          'blog/category-post-list/category-post-list-header-ajax': `.${this.postHeaderWrapper}`,
          'blog/category-post-list/category-post-list-ajax': `.${this.postListWrapper}`,
          'blog/category-post-list/category-post-list-pagination-ajax': `.${this.paginationWrapper}`,
        },
        success(res) {
          $(`.${this.sSearchIconActive}`).fadeIn();
          $(`.${this.sSearchIconClose}`).fadeOut();
          UrlGeneration.init();
          UrlGeneration.remove('search');
          UrlGeneration.update();
          this.success(res);
        },
      });
    });
  }
}();
